// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles to complement Tailwind CSS */

.App {
  text-align: left;
}

/* Smooth scrolling for the entire page */
html {
  scroll-behavior: smooth;
}

/* Custom scrollbar styles */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Focus styles for better accessibility */
button:focus,
input:focus,
select:focus,
textarea:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Custom animation for loading states */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Custom table hover effects */
.table-hover tbody tr:hover {
  background-color: #f8fafc;
  transition: background-color 0.15s ease-in-out;
}

/* Custom modal backdrop */
.modal-backdrop {
  backdrop-filter: blur(4px);
}

/* Print styles */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-break {
    page-break-before: always;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .text-gray-600 {
    color: #374151;
  }
  
  .text-gray-500 {
    color: #4b5563;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Custom utility classes */
.text-shadow {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.card-hover {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* Status badge custom colors */
.status-healthy {
  background-color: #dcfce7;
  color: #166534;
}

.status-warning {
  background-color: #fef3c7;
  color: #92400e;
}

.status-error {
  background-color: #fee2e2;
  color: #991b1b;
}

/* Custom form styling */
.form-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-input.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* Navigation active state */
.nav-link-active {
  background-color: #dbeafe;
  color: #1d4ed8;
  border-color: #3b82f6;
}

/* Loading spinner improvements */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Toast notification positioning */
.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
}

/* Responsive table improvements */
@media (max-width: 768px) {
  .table-responsive {
    overflow-x: auto;
  }
  
  .table-responsive table {
    min-width: 600px;
}
}

/* Dark mode preparation (for future implementation) */
@media (prefers-color-scheme: dark) {
  /* Dark mode styles can be added here when needed */
}

/* Custom gradient backgrounds */
.gradient-blue {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.gradient-green {
  background: linear-gradient(135deg, #10b981 0%, #047857 100%);
}

.gradient-purple {
  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);
  }

/* Skeleton loading animations */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.modal-close-btn:hover {
  background-color: #f3f4f6 !important;
  border-radius: 4px;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.transcript-content {
  max-height: 60vh;
  overflow-y: auto;
}

.transcript-chunk {
  transition: all 0.2s ease;
}

.transcript-chunk:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,2BAA2B;AAC3B;EACE,yCAAyC;AAC3C;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;AACpB;AACA;;AAEA,sDAAsD;AACtD;EACE,mDAAmD;AACrD;;AAEA,gCAAgC;AAChC;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D;;AAEF,gCAAgC;AAChC;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/* Custom styles to complement Tailwind CSS */\n\n.App {\n  text-align: left;\n}\n\n/* Smooth scrolling for the entire page */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Custom scrollbar styles */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Focus styles for better accessibility */\nbutton:focus,\ninput:focus,\nselect:focus,\ntextarea:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Custom animation for loading states */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Custom table hover effects */\n.table-hover tbody tr:hover {\n  background-color: #f8fafc;\n  transition: background-color 0.15s ease-in-out;\n}\n\n/* Custom modal backdrop */\n.modal-backdrop {\n  backdrop-filter: blur(4px);\n}\n\n/* Print styles */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-break {\n    page-break-before: always;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .text-gray-600 {\n    color: #374151;\n  }\n  \n  .text-gray-500 {\n    color: #4b5563;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* Custom utility classes */\n.text-shadow {\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.card-hover {\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.card-hover:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n/* Status badge custom colors */\n.status-healthy {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.status-warning {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.status-error {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n/* Custom form styling */\n.form-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.form-input.error {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n/* Navigation active state */\n.nav-link-active {\n  background-color: #dbeafe;\n  color: #1d4ed8;\n  border-color: #3b82f6;\n}\n\n/* Loading spinner improvements */\n.spinner-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Toast notification positioning */\n.toast-container {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1000;\n}\n\n/* Responsive table improvements */\n@media (max-width: 768px) {\n  .table-responsive {\n    overflow-x: auto;\n  }\n  \n  .table-responsive table {\n    min-width: 600px;\n}\n}\n\n/* Dark mode preparation (for future implementation) */\n@media (prefers-color-scheme: dark) {\n  /* Dark mode styles can be added here when needed */\n}\n\n/* Custom gradient backgrounds */\n.gradient-blue {\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n}\n\n.gradient-green {\n  background: linear-gradient(135deg, #10b981 0%, #047857 100%);\n}\n\n.gradient-purple {\n  background: linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%);\n  }\n\n/* Skeleton loading animations */\n.skeleton {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  max-width: 800px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modal-close-btn:hover {\n  background-color: #f3f4f6 !important;\n  border-radius: 4px;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.transcript-content {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.transcript-chunk {\n  transition: all 0.2s ease;\n}\n\n.transcript-chunk:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
